import { apiFetch } from '$lib/api/helpers';
import type { RoomRequest, RoomResponse } from '$lib/types/room';

const PATH = '/rooms/';

export async function fetchRooms() {
	return apiFetch<Array<RoomResponse>>(PATH);
}

export async function fetchRoomById(id: number) {
	return apiFetch<RoomResponse>(`${PATH}${id}/`);
}

export async function createRoom(roomRequest: RoomRequest) {
	return apiFetch<RoomResponse>(PATH, {
		method: 'POST',
		body: JSON.stringify(roomRequest)
	});
}

export async function deleteRoom(id: number) {
	return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}

export async function updateRoom(id: number, roomRequest: Partial<RoomRequest>) {
	return apiFetch<RoomResponse>(`${PATH}${id}/`, {
		method: 'PATCH',
		body: JSON.stringify(roomRequest)
	});
}

/** Alias used by inspectors — same as updateRoom. */
export const patchRoom = updateRoom;
